import { render, staticRenderFns } from "./CookieBanner.vue?vue&type=template&id=049578f9&scoped=true&"
import script from "./CookieBanner.vue?vue&type=script&lang=ts&"
export * from "./CookieBanner.vue?vue&type=script&lang=ts&"
import style0 from "./CookieBanner.vue?vue&type=style&index=0&id=049578f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049578f9",
  null
  
)

export default component.exports